import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./../Assesment/pages/Create_Assessment/create/create.css";
import axios from "../axios";
import CreateQuestion from "./QuestionEditCreate/CreateQuestion";
import ComponentType from "../Enum/ComponentTypeEnum";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";

const QuestionCreateMain = ({ componentType }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const standardList = [];
  const sectionList = [];
  const subjectList = [];
  const [click, setClick] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);
  const [specialChar1, setSpecialChar1] = useState(false);
  const [nameOfAS, setName] = useState("");
  const [nameofDescription, setNameofDescription] = useState("");
  const [assessmentTypesList, setAssessmentTypesList] = useState([]);
  const [assessmentEventsList, setAssessmentEventsList] = useState([]);
  const [assessmentTypesLoading, setAssessmentTypesLoading] = useState(false);
  const [assessmentEventsLoading, setAssessmentEventsLoading] = useState(false);
  const [assessmentConfigs, setAssessmentConfigs] = useState([]);
  const [assessmentConfigsLoading, setAssessmentConfigsLoading] =
    useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  // 🔥 FIX: Agar local storage mein currentStep 2 se bada hai (jaise 3), toh 1 maan lo. Agar questions saved hain toh 2.
  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = localStorage.getItem("currentStep");
    const savedData = JSON.parse(
      localStorage.getItem("temp_Questions_ASSESSMENT") || "null",
    );

    if (savedData?.questions?.length > 0) return 2;
    if (savedStep && Number(savedStep) <= 2) return Number(savedStep);
    return 1;
  });

  // ─── Existing assessment check states ──────────
  const [existingDialogOpen, setExistingDialogOpen] = useState(false);
  const [existingAssessment, setExistingAssessment] = useState([]);
  const [checkingExisting, setCheckingExisting] = useState(false);
  const [hasDuplicate, setHasDuplicate] = useState(false);

  // Load from localStorage on init
  const [assessmentDetails, setAssessmentDetails] = useState(() => {
    // 🔥 Data load karo initial state mein hi
    const savedData = JSON.parse(
      localStorage.getItem("temp_Questions_ASSESSMENT") || "null",
    );
    if (savedData?.assessmentDetails) {
      return savedData.assessmentDetails;
    }
    return {
      name: null,
      description: null,
      teacher_id: teacher_id,
      type_id: "",
      event_id: "",
      assessmentTypeId: "",
      assessmentEventId: "",
      standard_id: { id: state?.standardId ?? "", name: "" },
      section_id: { id: state?.sectionId ?? "", name: "" },
      subject_id: { id: state?.subjectId ?? "", name: "" },
      tags: [],
      status: null,
      total_duration: null,
      schedule_date: null,
      schedule_time: null,
      add_to_live_session: null,
      questions: [],
      maxMarks: null,
    };
  });

  const {
    standard_id,
    section_id,
    subject_id,
    name,
    description,
    type_id,
    event_id,
    total_duration,
  } = assessmentDetails;

  const [dropdownLists, setDropdownLists] = useState({
    standards: [],
    sections: [],
    assessmentTypes: [],
    subjects: [],
  });
  const { standards, sections, assessmentTypes, subjects } = dropdownLists;

  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  let school_id = JSON.parse(localStorage.getItem("schoolId"));

  // ─── Auto-generate Name & Description ──────────
  useEffect(() => {
    const subName = assessmentDetails.subject_id?.name || "";
    const stdName = assessmentDetails.standard_id?.name || "";
    const secName = assessmentDetails.section_id?.name || "";

    const selectedEvent = assessmentEventsList.find(
      (ev) => (ev.id || ev._id) === assessmentDetails.event_id,
    );
    const eventName = selectedEvent?.name || "";

    const selectedType = assessmentTypesList.find(
      (t) => (t._id || t.id) === assessmentDetails.type_id,
    );
    const typeName = selectedType?.name || "";

    let autoName = "";
    if (eventName && typeName) {
      autoName = `${eventName}_${typeName}`;
    }

    if (autoName) {
      const autoDesc = `Assessment for ${subName} in ${stdName} - ${secName} | Event: ${eventName} | Type: ${typeName}`;

      setName(autoName);
      setNameofDescription(autoDesc);
      setAssessmentDetails((prev) => ({
        ...prev,
        name: autoName,
        description: autoDesc,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    assessmentDetails.standard_id?.name,
    assessmentDetails.section_id?.name,
    assessmentDetails.subject_id?.name,
    assessmentDetails.event_id,
    assessmentDetails.type_id,
    assessmentEventsList,
    assessmentTypesList,
  ]);

  // ─── Fetch Assessment Events by Standard & Section ──────────
  const getAssessmentEventsByStandardSection = async (stdId, secId) => {
    if (!stdId || !secId || stdId === "null" || secId === "null") return;
    setAssessmentEventsLoading(true);
    try {
      let res = await axios.get(
        `/api/v1/performance/assessment-events?schoolId=${school_id}`,
      );
      const data = res?.data?.data || res?.data || [];
      const activeEvents = data.filter(
        (ev) => ev.status === true || ev.status === "Active",
      );
      setAssessmentEventsList(activeEvents);
    } catch (error) {
      console.log("Error fetching assessment events:", error);
      setAssessmentEventsList([]);
    } finally {
      setAssessmentEventsLoading(false);
    }
  };

  // ─── Fetch Assessment Configurations ──────────
  const getAssessmentConfigurations = async (stdId, secId, eventId) => {
    if (
      !stdId ||
      !secId ||
      !eventId ||
      stdId === "null" ||
      secId === "null" ||
      eventId === "null"
    ) {
      setAssessmentConfigs([]);
      setAssessmentTypesList([]);
      return;
    }
    setAssessmentConfigsLoading(true);
    setAssessmentTypesLoading(true);
    try {
      let res = await axios.get(
        `/api/v1/performance/assessment-configurations?standardId=${stdId}&sectionId=${secId}&assessmentEventId=${eventId}`,
      );
      const configs = res?.data?.data || res?.data || [];
      setAssessmentConfigs(configs);
    } catch (error) {
      console.log("Error fetching assessment configurations:", error);
      setAssessmentConfigs([]);
      setAssessmentTypesList([]);
    } finally {
      setAssessmentConfigsLoading(false);
      setAssessmentTypesLoading(false);
    }
  };

  const getAssessmentType = async () => {
    try {
      let res = await axios.get(
        `/api/v1/assessment/assessmentType/get/school/${school_id}`,
      );
      res &&
        setDropdownLists((prev) => ({
          ...prev,
          assessmentTypes: res.data.data,
        }));
    } catch (error) {
      console.log(error);
    }
  };

  // ─── Check if assessment already exists ──────────
  const checkExistingAssessment = async () => {
    const stdId = assessmentDetails?.standard_id?.id;
    const secId = assessmentDetails?.section_id?.id;
    const eventId = assessmentDetails?.event_id;
    const subjectId = assessmentDetails?.subject_id?.id;

    const academicSessionId = JSON.parse(
      localStorage.getItem("academicYearSessionId") || "null",
    );
    const timetableSessionId = JSON.parse(
      localStorage.getItem("timeTableSessionId") || "null",
    );

    if (
      !stdId ||
      !secId ||
      !eventId ||
      !subjectId ||
      stdId === "null" ||
      secId === "null" ||
      eventId === "null" ||
      subjectId === "null"
    ) {
      return null;
    }

    try {
      setCheckingExisting(true);
      const res = await axios.get(
        `/api/v1/assessment/filter?standardId=${stdId}&sectionId=${secId}&assessmentEventId=${eventId}&subjectId=${subjectId}&academicSessionId=${academicSessionId}&timetableSessionId=${timetableSessionId}`,
      );
      const rawData = res?.data?.data;
      const data = Array.isArray(rawData) ? rawData : rawData ? [rawData] : [];
      return data.length > 0 ? data : null;
    } catch (error) {
      console.log("Error checking existing assessment:", error);
      return null;
    } finally {
      setCheckingExisting(false);
    }
  };

  // ─── Sync maxMarks into assessmentDetails ───
  useEffect(() => {
    const config = assessmentConfigs.find(
      (cfg) =>
        (cfg?.subjectId?._id === assessmentDetails?.subject_id?.id ||
          cfg?.subjectId?.id === assessmentDetails?.subject_id?.id) &&
        (cfg?.assessmentTypeId?._id === assessmentDetails?.type_id ||
          cfg?.assessmentTypeId?.id === assessmentDetails?.type_id),
    );

    const marks =
      config?.maxMarks ??
      config?.totalMarks ??
      config?.max_marks ??
      config?.maxScore ??
      null;

    if (
      marks != null &&
      Number(assessmentDetails?.maxMarks) !== Number(marks)
    ) {
      setAssessmentDetails((prev) => ({ ...prev, maxMarks: marks }));

      const savedTemp = JSON.parse(
        localStorage.getItem("temp_Questions_ASSESSMENT") || "{}",
      );
      if (savedTemp?.questions?.length > 0) {
        localStorage.setItem(
          "temp_Questions_ASSESSMENT",
          JSON.stringify({
            ...savedTemp,
            assessmentDetails: { ...assessmentDetails, maxMarks: marks },
            questions: savedTemp.questions || [],
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    assessmentDetails?.subject_id?.id,
    assessmentDetails?.type_id,
    assessmentConfigs,
  ]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (unsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [unsavedChanges]);

  useEffect(() => {
    if (classTeacher_JSON && classTeacher_JSON.length > 0) {
      classTeacher_JSON?.forEach((obj) => {
        if (obj?.is_class_teacher === true) {
          if (!standardList.some((i) => i.id === obj.standard_id.id)) {
            standardList.push(obj.standard_id);
          }
          if (!sectionList.some((i) => i.id === obj.section_id.id)) {
            sectionList.push(obj.section_id);
          }
          let subjects = obj.subjects_id;
          if (subjects.length > 0) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        }
      });
    }

    if (cordinator_JSON && cordinator_JSON.length > 0) {
      cordinator_JSON?.forEach((obj) => {
        if (obj?.is_class_co_ordinator === true) {
          if (!standardList.some((i) => i.id === obj.standard_id.id)) {
            standardList.push(obj.standard_id);
          }
          if (!sectionList.some((i) => i.id === obj.section_id.id)) {
            sectionList.push(obj.section_id);
          }
          let subjects = obj.subjects_id;
          if (subjects.length > 0) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        }
      });
    }

    if (generalRole_JSON && generalRole_JSON.length > 0) {
      generalRole_JSON?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }

    getAssessmentType();
    standardList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, standards: standardList }));

    sectionList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, sections: sectionList }));
  }, [state]);

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === assessmentDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === assessmentDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === assessmentDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      let res = await axios.get(
        `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
      );
      const data = res?.data?.data;
      const subjectSource =
        data?.subjectConfigurations?.length > 0
          ? data.subjectConfigurations
              .filter((item) => item.subjectCategory === "SCHOLASTIC")
              .map((item) => item.subject)
          : data.subjects;

      subjectSource.forEach((obj) => {
        arrSubject.push(obj);
      });
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  useEffect(() => {
    (async () => {
      let subjects = [];
      const stdId = assessmentDetails.standard_id?.id;
      const secId = assessmentDetails.section_id?.id;

      if (
        ((classTeacher_JSON && classTeacher_JSON.length > 0) ||
          (cordinator_JSON && cordinator_JSON.length > 0)) &&
        stdId !== "null" &&
        secId !== "null"
      ) {
        subjects = await getSubjects(stdId, secId);
      }
      if (classTeacher_JSON && classTeacher_JSON.length > 0) {
        classTeacher_JSON?.forEach(async (obj) => {
          if (obj.standard_id.id === stdId && obj.section_id.id === secId) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (cordinator_JSON && cordinator_JSON.length > 0) {
        cordinator_JSON?.forEach(async (obj) => {
          if (obj.standard_id.id === stdId && obj.section_id.id === secId) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (generalRole_JSON && generalRole_JSON.length > 0) {
        generalRole_JSON?.forEach((obj) => {
          let subjects = obj.subjects_id;
          if (obj.standard_id.id === stdId && obj.section_id.id === secId) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        });
      }

      subjectList.length > 0 &&
        setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));

      if (stdId && secId && stdId !== "null" && secId !== "null") {
        getAssessmentEventsByStandardSection(stdId, secId);
      } else {
        setAssessmentEventsList([]);
      }
    })();
  }, [assessmentDetails.standard_id, assessmentDetails.section_id]);

  useEffect(() => {
    const stdId = assessmentDetails.standard_id?.id;
    const secId = assessmentDetails.section_id?.id;
    const eventId = assessmentDetails.event_id;

    if (
      stdId &&
      secId &&
      eventId &&
      stdId !== "null" &&
      secId !== "null" &&
      eventId !== "null"
    ) {
      getAssessmentConfigurations(stdId, secId, eventId);
    } else {
      setAssessmentConfigs([]);
      setAssessmentTypesList([]);
    }
  }, [assessmentDetails.event_id]);

  useEffect(() => {
    const subjectId = assessmentDetails?.subject_id?.id;

    if (!subjectId || subjectId === "null") {
      setAssessmentTypesList([]);
      return;
    }

    const filteredConfigs = assessmentConfigs.filter(
      (config) =>
        config?.subjectId?._id === subjectId ||
        config?.subjectId?.id === subjectId,
    );

    const uniqueTypes = [];
    const typeIds = new Set();

    filteredConfigs.forEach((config) => {
      const type = config?.assessmentTypeId;
      if (type && !typeIds.has(type._id || type.id)) {
        typeIds.add(type._id || type.id);
        uniqueTypes.push(type);
      }
    });

    setAssessmentTypesList(uniqueTypes);
  }, [assessmentDetails?.subject_id?.id, assessmentConfigs]);

  const selectedConfig = assessmentConfigs.find(
    (config) =>
      (config?.subjectId?._id === assessmentDetails?.subject_id?.id ||
        config?.subjectId?.id === assessmentDetails?.subject_id?.id) &&
      (config?.assessmentTypeId?._id === assessmentDetails?.type_id ||
        config?.assessmentTypeId?.id === assessmentDetails?.type_id),
  );

  const maxMarks =
    selectedConfig?.maxMarks ??
    selectedConfig?.totalMarks ??
    selectedConfig?.max_marks ??
    selectedConfig?.maxScore ??
    null;

  useEffect(() => {
    if (
      standards.length > 0 &&
      sections.length > 0 &&
      state?.defaultRouteData?.standardId &&
      state?.defaultRouteData?.sectionId
    ) {
      const standard = standards.find(
        (s) => s.id === state.defaultRouteData.standardId,
      );
      const section = sections.find(
        (s) => s.id === state.defaultRouteData.sectionId,
      );
      if (!standard || !section) return;

      setAssessmentDetails((prev) => ({
        ...prev,
        standard_id: { id: standard.id, name: standard.name },
        section_id: { id: section.id, name: section.name },
      }));
    }
  }, [standards, sections]);

  useEffect(() => {
    if (
      subjects &&
      subjects.length > 0 &&
      state?.defaultRouteData?.subjectId !== undefined
    ) {
      let subject = subjects.filter(
        (subject) => subject.id === state.defaultRouteData.subjectId,
      );
      setAssessmentDetails({
        ...assessmentDetails,
        subject_id: {
          id: subject[0]?.id,
          name: subject[0]?.name,
        },
      });
    }
  }, [subjects]);

  const steps = [1, 2];
  const isPreviousDisabled = currentStep === 1;

  const isEmpty = (val) =>
    val === undefined || val === null || val === "" || val === "null";

  const isStep1Invalid =
    isEmpty(assessmentDetails?.standard_id?.id) ||
    isEmpty(assessmentDetails?.section_id?.id) ||
    isEmpty(assessmentDetails?.subject_id?.id) ||
    isEmpty(assessmentDetails?.event_id) ||
    isEmpty(assessmentDetails?.type_id) ||
    isEmpty(assessmentDetails?.total_duration) ||
    !assessmentDetails?.name;

  const isNextDisabled = isStep1Invalid || hasDuplicate;

  // 🔥 FIX: Local storage load hote hi step 2 par bhejo agar data hai
  useEffect(() => {
    const savedTempLocalAssesment = JSON.parse(
      localStorage.getItem("temp_Questions_ASSESSMENT"),
    );
    if (!savedTempLocalAssesment) return;

    if (savedTempLocalAssesment?.assessmentDetails) {
      setAssessmentDetails(savedTempLocalAssesment.assessmentDetails);
      setName(savedTempLocalAssesment.assessmentDetails.name || "");
      setNameofDescription(
        savedTempLocalAssesment.assessmentDetails.description || "",
      );
    }

    if (savedTempLocalAssesment?.questions?.length > 0) {
      setCurrentStep(2); // Direct Step 2
    }
  }, []);

  const updateAssessmentDetails = (newDetails) => {
    const updated = {
      ...assessmentDetails,
      ...newDetails,
    };

    setAssessmentDetails(updated);

    if (hasDuplicate) setHasDuplicate(false);

    const savedTemp = JSON.parse(
      localStorage.getItem("temp_Questions_ASSESSMENT") || "{}",
    );

    if (!savedTemp) return;

    if (savedTemp?.questions?.length > 0) {
      localStorage.setItem(
        "temp_Questions_ASSESSMENT",
        JSON.stringify({
          ...savedTemp,
          assessmentDetails: updated,
          questions: savedTemp?.questions || [],
        }),
      );
    }
  };

  const handleBackNavigation = () => {
    if (state?.defaultRouteData?.fromLiveSession === "liveSession") {
      navigate("/liveSession", {
        state: {
          supplement_id: state?.defaultRouteData?.supplement_id,
          addMaterial: state?.defaultRouteData?.redirectStateData?.addMaterial,
          standardId: state?.defaultRouteData?.standardId,
          sectionId: state?.defaultRouteData?.sectionId,
          Subject_id:
            state?.defaultRouteData?.subjectId ??
            state?.defaultRouteData?.Subject_id,
          buttonfunction:
            state?.defaultRouteData?.redirectStateData?.buttonfunction,
          sectionName: state?.defaultRouteData?.redirectStateData?.sectionName,
          standardsName:
            state?.defaultRouteData?.redirectStateData?.standardsName,
        },
      });
    } else {
      navigate("/publishedAssessment");
      setUnsavedChanges(true);
    }
  };

  const handleNextClick = async () => {
    if (currentStep === 1) {
      const existing = await checkExistingAssessment();

      if (existing && existing.length > 0) {
        setExistingAssessment(existing);
        setExistingDialogOpen(true);
        setHasDuplicate(true);
        return;
      }
    }
    setCurrentStep(currentStep + 1);
  };

  return (
    <>
      <div className="create_wrap w-100 h-100">
        {currentStep !== 2 && (
          <div
            className="mb-4"
            onClick={() => {
              handleBackNavigation();
            }}
          >
            <div
              className="mb-4 d-flex align-items-center gap-2"
              onClick={() => {
                handleBackNavigation();
              }}
              style={{ cursor: "pointer" }}
            >
              <IoIosArrowBack
                onClick={() => {
                  handleBackNavigation();
                }}
                style={{ cursor: "pointer" }}
              />
              <div className="d-flex flex-column gap-1">
                <span className="head_manual">
                  {componentType == ComponentType.ASSESSMENT &&
                    "Publish Assessment"}
                  {componentType == ComponentType.HOMEWORK &&
                    "Publish Homework"}
                </span>
                <span
                  className="fw-small  text-muted"
                  style={{ fontSize: "10px" }}
                >
                  Dashboard / Assessment / Create Assessment
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="w-100 h-100 py-1 " style={{ backgroundColor: "#fff" }}>
          <div className="d-flex align-items-center justify-content-center my-2 w-100">
            <div className="d-flex align-items-center">
              {steps.map((step, index) => {
                const isCompleted = currentStep > step;
                const isActive = currentStep === step;

                return (
                  <React.Fragment key={step}>
                    <div className="d-flex align-items-center">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: 36,
                          height: 36,
                          backgroundColor:
                            isCompleted || isActive ? "#7e4c32" : "#ccc",
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: 14,
                        }}
                      >
                        {isCompleted ? "✓" : step}
                      </div>

                      <span
                        className="ms-2 me-3"
                        style={{
                          fontSize: 14,
                          fontWeight: isActive ? 600 : 400,
                          color: isActive ? "#000" : "#999",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Step {step}
                      </span>
                    </div>

                    {index !== steps.length - 1 && (
                      <div
                        style={{
                          width: 80,
                          height: 2,
                          backgroundColor: isCompleted ? "#7e4c32" : "#ddd",
                          marginRight: 12,
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            {componentType === ComponentType.ASSESSMENT && (
              <div
                className="ms-3 d-flex align-items-center justify-content-center bg-white shadow-sm"
                style={{
                  width: 112,
                  height: 64,
                  borderRadius: 10,
                  padding: "6px",
                }}
              >
                <img
                  src={
                    state?.selectedBox === "adaptive"
                      ? "/images/adaptiveImg.png"
                      : state?.selectedBox === "auto-evaluate"
                        ? "/images/auto-eva.png"
                        : "/images/teacher-eva.png"
                  }
                  alt=""
                  style={{
                    maxHeight: 32,
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            )}
          </div>

          {currentStep === 1 && (
            <Box className="total_dropdown">
              <Box className="create_dropdown1 p-0 col-12 my-custom-margin">
                <Box display="flex" gap={2} className="col-6 p-0">
                  <FormControl
                    size="small"
                    fullWidth
                    disabled={
                      state?.defaultRouteData?.defaultData !== undefined
                    }
                  >
                    <InputLabel>Select Class</InputLabel>
                    <Select
                      label="Select Class"
                      value={assessmentDetails?.standard_id?.id || ""}
                      onChange={(e) => {
                        const selected = standardArr?.find(
                          (s) => s.id === e.target.value,
                        );
                        updateAssessmentDetails({
                          standard_id: {
                            id: selected?.id || "",
                            name: selected?.name || "",
                          },
                          subject_id: { id: "null", name: "null" },
                          section_id: { id: "null", name: "null" },
                        });
                      }}
                    >
                      <MenuItem value="">Select Class</MenuItem>
                      {standardArr?.length > 0 &&
                        [...standardArr]
                          .sort((a, b) => {
                            const aNum = Number(a.name);
                            const bNum = Number(b.name);
                            const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                            if (bothNumeric) {
                              return aNum - bNum;
                            }
                            return a.name.localeCompare(b.name);
                          })
                          .map((standard, index) => (
                            <MenuItem
                              key={standard?.id || index}
                              value={standard?.id}
                              name={standard?.name}
                            >
                              {standard?.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>

                  <FormControl
                    size="small"
                    fullWidth
                    disabled={
                      state?.defaultRouteData?.defaultData !== undefined
                    }
                  >
                    <InputLabel>Select Section</InputLabel>
                    <Select
                      label="Select Section"
                      value={assessmentDetails?.section_id?.id || ""}
                      onChange={(e) => {
                        const selectedSection = sectionArr.find(
                          (s) => s.id === e.target.value,
                        );
                        updateAssessmentDetails({
                          section_id: {
                            id: selectedSection?.id || "",
                            name: selectedSection?.name || "",
                          },
                          subject_id: { id: "null", name: "null" },
                        });
                      }}
                    >
                      <MenuItem value="">Select Section</MenuItem>
                      {standard_id?.id !== "null" &&
                        sectionArr
                          ?.slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((section) => (
                            <MenuItem key={section.id} value={section.id}>
                              {section.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Box>

                <FormControl size="small" fullWidth>
                  <InputLabel>
                    {assessmentEventsLoading
                      ? "Loading Events..."
                      : "Select Assessment Event"}
                  </InputLabel>
                  <Select
                    label="Select Assessment Event"
                    value={assessmentDetails?.event_id || ""}
                    onChange={(e) => {
                      const selectedEvent = assessmentEventsList.find(
                        (ev) => (ev.id || ev._id) === e.target.value,
                      );
                      updateAssessmentDetails({
                        event_id: e.target.value,
                        assessmentEventId: e.target.value,
                        assessmentTypeId: "",
                        type_id: "",
                        subject_id: { id: "null", name: "null" },
                        event_name: selectedEvent?.name || "",
                      });
                    }}
                    disabled={
                      assessmentEventsLoading ||
                      !assessmentDetails.standard_id?.id ||
                      !assessmentDetails.section_id?.id ||
                      assessmentDetails.standard_id?.id === "null" ||
                      assessmentDetails.section_id?.id === "null"
                    }
                  >
                    <MenuItem value="">
                      {assessmentEventsLoading
                        ? "Loading..."
                        : assessmentDetails.standard_id?.id &&
                            assessmentDetails.standard_id?.id !== "null"
                          ? "Select Assessment Event"
                          : "Select Class & Section First"}
                    </MenuItem>
                    {assessmentEventsList?.length > 0 &&
                      assessmentEventsList.map((event) => (
                        <MenuItem
                          key={event.id || event._id}
                          value={event.id || event._id}
                        >
                          {event.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>

              <Box className="create_dropdown1 p-0 col-12 my-custom-margin">
                <Box display="flex" gap={2} className="col-9 p-0">
                  <FormControl
                    size="small"
                    fullWidth
                    disabled={
                      state?.defaultRouteData?.defaultData !== undefined
                    }
                  >
                    <InputLabel>Select Subject</InputLabel>
                    <Select
                      label="Select Subject"
                      value={assessmentDetails?.subject_id?.id || ""}
                      disabled={!assessmentDetails?.event_id}
                      onChange={(e) => {
                        const selectedSubject = subjects.find(
                          (s) => s.id === e.target.value,
                        );
                        updateAssessmentDetails({
                          subject_id: {
                            id: selectedSubject?.id || "",
                            name: selectedSubject?.name || "",
                          },
                          type_id: "",
                          assessmentTypeId: "",
                        });
                      }}
                    >
                      <MenuItem value="">Select Subject</MenuItem>
                      {standard_id?.id !== "null" &&
                        section_id?.id !== "null" &&
                        subjects?.map((subject) => {
                          const hasConfig = assessmentConfigs.some(
                            (cfg) =>
                              cfg.subjectId?._id === subject.id ||
                              cfg.subjectId?.id === subject.id,
                          );
                          if (
                            !assessmentDetails.event_id ||
                            assessmentDetails.event_id === "null" ||
                            hasConfig
                          ) {
                            return (
                              <MenuItem key={subject.id} value={subject.id}>
                                {subject.name}
                              </MenuItem>
                            );
                          }
                          return null;
                        })}
                    </Select>
                  </FormControl>

                  <FormControl size="small" fullWidth>
                    <InputLabel>
                      {assessmentConfigsLoading
                        ? "Loading..."
                        : assessmentTypesLoading
                          ? "Loading Types..."
                          : "Select Assessment Type"}
                    </InputLabel>
                    <Select
                      label="Select Assessment Type"
                      value={assessmentDetails?.type_id || ""}
                      onChange={(e) => {
                        const selectedType = assessmentTypesList.find(
                          (t) => (t._id || t.id) === e.target.value,
                        );
                        updateAssessmentDetails({
                          type_id: e.target.value,
                          assessmentTypeId: e.target.value,
                          type_name: selectedType?.name || "",
                        });
                      }}
                      disabled={
                        assessmentConfigsLoading ||
                        assessmentTypesLoading ||
                        !assessmentDetails.standard_id?.id ||
                        assessmentDetails.standard_id?.id === "null" ||
                        !assessmentDetails.section_id?.id ||
                        assessmentDetails.section_id?.id === "null" ||
                        !assessmentDetails.event_id ||
                        assessmentDetails.event_id === "null" ||
                        !assessmentDetails.subject_id?.id ||
                        assessmentDetails.subject_id?.id === "null"
                      }
                    >
                      <MenuItem value="">
                        {assessmentConfigsLoading || assessmentTypesLoading
                          ? "Loading..."
                          : assessmentDetails.event_id &&
                              assessmentDetails.event_id !== "null"
                            ? "Select Assessment Type"
                            : "Select Event First"}
                      </MenuItem>
                      {assessmentTypesList?.length > 0 &&
                        assessmentTypesList.map((type) => (
                          <MenuItem
                            key={type._id || type.id}
                            value={type._id || type.id}
                          >
                            {type.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <TextField
                    size="small"
                    type="number"
                    label="Duration (In minutes)"
                    value={assessmentDetails.total_duration}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (/^\d*$/.test(value) || value === "") {
                        const maxValue = 1440;
                        if (value === "" || parseInt(value) <= maxValue) {
                          updateAssessmentDetails({
                            total_duration: value,
                          });
                        }
                      }
                    }}
                    inputProps={{ min: 0, max: 1440, maxLength: 4 }}
                    sx={{
                      width: "100%",
                      color:
                        assessmentDetails.total_duration > 0
                          ? "black"
                          : "#668598",
                    }}
                  />
                </Box>

                <TextField
                  size="small"
                  label="Total Marks"
                  fullWidth
                  value={maxMarks ?? ""}
                  placeholder={maxMarks ? "" : "Select Subject & Type first"}
                  disabled
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      backgroundColor: "#faf7f5",
                      borderRadius: 2,
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "#4a3b32",
                      fontWeight: 700,
                      fontSize: 15,
                    },
                    "& .MuiInputLabel-root": {
                      color: "#a1938a",
                      fontWeight: 600,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#efe5df",
                    },
                  }}
                />
              </Box>
            </Box>
          )}

          {currentStep !== 2 && (
            <div className="d-flex align-items-center justify-content-end p-4 w-100 gap-4">
              <button
                className={
                  isPreviousDisabled ? "Next_buttonDisable" : "button_css"
                }
                disabled={isPreviousDisabled}
                onClick={() => setCurrentStep(currentStep - 1)}
              >
                Previous
              </button>
              <button
                disabled={isNextDisabled || checkingExisting || hasDuplicate}
                className={
                  isNextDisabled || checkingExisting || hasDuplicate
                    ? "Next_buttonDisable"
                    : "button_css"
                }
                onClick={handleNextClick}
                style={{ marginRight: "6rem" }}
              >
                {checkingExisting ? "Checking..." : "Next"}
              </button>
            </div>
          )}

          {currentStep === 2 && (
            <CreateQuestion
              setClickFromCreate={setCurrentStep}
              assessmentDetails={assessmentDetails}
              setAssessmentDetails={setAssessmentDetails}
              componentType={componentType}
              setUnsavedChanges={setUnsavedChanges}
              redirectStateData={
                state?.defaultRouteData?.redirectStateData ?? null
              }
              selectedBox={state?.selectedBox}
            />
          )}
        </div>
      </div>

      {/* ─── Already Exists Dialog (unchanged) ─── */}
      <Dialog
        open={existingDialogOpen}
        onClose={() => setExistingDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            fontWeight: 700,
            color: "#7e4c32",
            pb: 2,
            pt: 3,
            px: 3,
            borderBottom: "1px solid #f0e6e0",
            backgroundColor: "#fffaf7",
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              backgroundColor: "#fdf1ea",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 24,
              flexShrink: 0,
            }}
          >
            ⚠️
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: "#7e4c32", lineHeight: 1.2 }}
            >
              Assessment Already Exists
            </Typography>
            <Typography variant="caption" sx={{ color: "#8a7b73" }}>
              {existingAssessment?.length || 0} existing assessment
              {existingAssessment?.length > 1 ? "s" : ""} found — please change
              your selections to continue
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{
            pt: 3,
            px: 3,
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              maxHeight: 380,
              overflowY: "auto",
              pr: 1,
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f3ece8",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c8a48d",
                borderRadius: "10px",
                border: "2px solid #f3ece8",
                "&:hover": {
                  backgroundColor: "#a87a5c",
                },
              },
              scrollbarWidth: "thin",
              scrollbarColor: "#c8a48d #f3ece8",
            }}
          >
            {existingAssessment?.map((item, idx) => {
              const status = String(item?.status || "").toLowerCase();
              const statusColor =
                status === "draft"
                  ? "#d97706"
                  : status === "published"
                    ? "#16a34a"
                    : status === "completed"
                      ? "#2563eb"
                      : status === "review"
                        ? "#9333ea"
                        : "#7e4c32";
              const statusBg =
                status === "draft"
                  ? "#fef3c7"
                  : status === "published"
                    ? "#dcfce7"
                    : status === "completed"
                      ? "#dbeafe"
                      : status === "review"
                        ? "#f3e8ff"
                        : "#fdf1ea";

              return (
                <Box
                  key={item?.id || idx}
                  sx={{
                    border: "1px solid #efe5df",
                    borderRadius: 2,
                    p: 2,
                    backgroundColor: "#faf7f5",
                    transition: "all 0.2s",
                    "&:hover": {
                      boxShadow: "0 2px 10px rgba(126,76,50,0.1)",
                      borderColor: "#d9c4b8",
                    },
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    gap={2}
                    mb={1.2}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={700}
                      sx={{ color: "#2b2b2b", wordBreak: "break-word" }}
                    >
                      {item?.name || "Untitled Assessment"}
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor: statusBg,
                        color: statusColor,
                        px: 1.2,
                        py: 0.4,
                        borderRadius: 1,
                        fontSize: 11,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                        flexShrink: 0,
                      }}
                    >
                      {item?.status || "—"}
                    </Box>
                  </Box>

                  {item?.description && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#7a6f68",
                        mb: 1.5,
                        fontSize: 13,
                        fontStyle: "italic",
                      }}
                    >
                      {item.description}
                    </Typography>
                  )}

                  <Box
                    display="flex"
                    flexWrap="wrap"
                    gap={1.5}
                    sx={{ fontSize: 12 }}
                  >
                    {item?.assessmentTypeId?.name && (
                      <Box display="flex" alignItems="center" gap={0.6}>
                        <span style={{ color: "#a1938a" }}>Type:</span>
                        <strong style={{ color: "#4a3b32" }}>
                          {item.assessmentTypeId.name}
                        </strong>
                      </Box>
                    )}
                    {item?.assessmentEventId?.name && (
                      <Box display="flex" alignItems="center" gap={0.6}>
                        <span style={{ color: "#a1938a" }}>Event:</span>
                        <strong style={{ color: "#4a3b32" }}>
                          {item.assessmentEventId.name}
                        </strong>
                      </Box>
                    )}
                    {item?.total_questions != null && (
                      <Box display="flex" alignItems="center" gap={0.6}>
                        <span style={{ color: "#a1938a" }}>Questions:</span>
                        <strong style={{ color: "#4a3b32" }}>
                          {item.total_questions}
                        </strong>
                      </Box>
                    )}
                    {item?.total_marks != null && (
                      <Box display="flex" alignItems="center" gap={0.6}>
                        <span style={{ color: "#a1938a" }}>Marks:</span>
                        <strong style={{ color: "#4a3b32" }}>
                          {item.total_marks}
                        </strong>
                      </Box>
                    )}
                    {item?.total_duration != null && (
                      <Box display="flex" alignItems="center" gap={0.6}>
                        <span style={{ color: "#a1938a" }}>Duration:</span>
                        <strong style={{ color: "#4a3b32" }}>
                          {item.total_duration} min
                        </strong>
                      </Box>
                    )}
                  </Box>

                  {item?.created_at && (
                    <Typography
                      variant="caption"
                      sx={{ display: "block", mt: 1.2, color: "#a1938a" }}
                    >
                      Created on{" "}
                      {new Date(item.created_at).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>

          <Box
            sx={{
              mt: 2.5,
              p: 1.5,
              backgroundColor: "#fdecea",
              border: "1px solid #f5c6c2",
              borderRadius: 1.5,
            }}
          >
            <Typography variant="caption" sx={{ color: "#b91c1c" }}>
              🚫 <strong>Duplicate Not Allowed:</strong> Please change your
              Class / Section / Event / Subject / Type to continue to the next
              step.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 2.5,
            pt: 2,
            gap: 1.5,
            borderTop: "1px solid #f0e6e0",
            backgroundColor: "#fffaf7",
          }}
        >
          <Button
            onClick={() => setExistingDialogOpen(false)}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#7e4c32",
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(126,76,50,0.25)",
              "&:hover": {
                backgroundColor: "#5c3623",
                boxShadow: "0 4px 12px rgba(126,76,50,0.3)",
              },
            }}
          >
            OK, Change Selection
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default QuestionCreateMain;
